module.exports = __webpack_public_path__ + "img/partner.3d842f60.jpg";